module.exports = __webpack_public_path__ + "img/ml.65d0a5e6.svg";